import { useMediaQuery } from '@educaplay/core';

export default function useIsTouchDevice() {
    const isTouchDevice = useMediaQuery("(hover:none)") || ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0);
    const isDesktop = useMediaQuery("sm");

    return isTouchDevice && !isDesktop;
}